import { View } from "react-native";
import { Text } from "react-native-paper";
import { useCurrentUser } from "../../hooks";

import { ActionsContainer, Button, ScreenContainer, ScrollableContainer } from "../../components";
import { QUERY, Query } from "./utils";
import { useQuery } from "@apollo/client";
import LottieView from "lottie-react-native";

export default function SuccessScreen() {
  const { data } = useQuery<Query>(QUERY);
  const newEmail = data?.currentMember.primaryEmail;
  const { logout } = useCurrentUser();
  return (
    <ScreenContainer testID="SuccessScreen">
      <ScrollableContainer>
        <View className="px-10 py-16">
          <View className="h-36 my-8">
            <LottieView
              style={{ flex: 1 }}
              autoPlay
              loop={false}
              source={require("../../../assets/lottie-icons/profile.json")}
            />
          </View>

          <Text className="text-title-3 font-700 text-center mb-6">Email Successfully Changed</Text>
          <Text className="text-regular-normal mb-5">
            Note: It may take several minutes before your new email is reflected online in places like the pga.org directory or
            your pga.org dashboard.
          </Text>

          <Text className="text-regular-normal">Tap “Close and Log In” below to log in with your new username:</Text>
          <Text className="text-regular-normal font-700 mb-5">{newEmail}.</Text>

          <Text className="text-regular-normal font-700">Your password will remain the same.</Text>
        </View>
      </ScrollableContainer>
      <ActionsContainer>
        <Button testID="submit" onPress={logout} mode="contained">
          Close and Log In
        </Button>
      </ActionsContainer>
    </ScreenContainer>
  );
}
